/**
 * AP bill READ endpoints — request schemas + wire types.
 *
 * Like `expensesReads.ts`, these serve plain RLS-scoped reads: the Hono
 * handlers run the queries through the per-request user client, so org RLS
 * does the authorization (docs/BACKEND_API.md → "Read endpoints").
 *
 * The wire interfaces are shared by the API handlers (response construction)
 * and the web hooks (`unwrap<T>` targets) so the two sides cannot drift.
 * `apps/web/src/hooks/useAccountsPayable.ts` keeps exposing its established
 * `APInvoice` shape by composing these (narrowing `tax_treatment` etc.).
 */
import { z } from "zod";
// ---------------------------------------------------------------------------
// Query-param schemas
// ---------------------------------------------------------------------------
/** Query params for GET /orgs/:orgId/ap-invoices/index. */
export const apBillIndexQuerySchema = z.object({
    projectId: z.string().uuid().optional(),
    businessId: z.string().uuid().optional(),
    personId: z.string().uuid().optional(),
});
//# sourceMappingURL=apBillsReads.js.map